import { TdPaginationMiniProps } from './type';

export const paginationMiniDefaultProps: TdPaginationMiniProps = {
  layout: 'horizontal',
  showCurrent: true,
  size: 'medium',
  variant: 'text',
};
